import gql from 'graphql-tag';

export const GET_NEXT_PAGE = gql`
  query getNextOrPreviousPage($contentPageId: Int!, $navigation: EContentPageNavigationDirection!, $userFlowStepTrackId: Int!) {
    contentPage {
      getNextOrPreviousPage(currentPageId: $contentPageId, navigation: $navigation, trackingId: $userFlowStepTrackId) {
        id
        title
        url
      }
    }
  }
`;
